'use strict';

const UNLINK = 'Remove',
	INVITE = 'Add existing user';

module.exports = require('ck-core/source/functions/makeLang')({
	LOGOUT_BILLING_ONLY_PROMPT: `You'll need to follow the link we emailed you to get back to this page.\n\nIf you're trying to get to the code editor, use the account slots on this page.`,
	CONFIRM_LOGOUT_TITLE: 'Are you sure you want to logout?',
	CONFIRM_UNLINK: {
		TITLE: `Confirm ${UNLINK}`,
		MESSAGE: `Are you sure you want to ${UNLINK.toLowerCase()} this account? They will lose access to your payment plan.\n\nIf you want to add them back, you must use the "${INVITE}" button.`
	},
	ACTIONS: {
		UNLINK,
		START_CODING: 'Start coding',
		COPY_LINK: 'Copy register link',
		INVITE,
		GIFT_PDF: 'Gift PDF'
	}
});
